module.exports = __webpack_public_path__ + "static/media/country_vc.fca12c99.webp";